<template>
  <div class="contents">
    <div class="title">
      <span>{{ $t("howto.header-message") }}</span>
      <p class="app-msg">{{ $t("howto.header-message-ext") }}</p>
    </div>
    <div class="img-coffee">
      <img class="img-coffee-method" :src="imgPath" alt="coffee-image."/>
    </div>
    <div class="choose-methods">
      <b-form-select v-model="curMethod" v-on:change="selectMethod($event)" >
        <option :value="null" disabled>-- {{ $t("cmn.choose-method") }} --</option>
        <option :value="1">{{ $t(map[1].method_name) }}</option>
        <option :value="2">{{ $t(map[2].method_name) }}</option>
        <option :value="3">{{ $t(map[3].method_name) }}</option>
      </b-form-select>
    </div>
    <div v-if="curMethod" v-html="howtoMake" class="howto-make"></div>
  </div>
</template>

<script>
export default {
  name: 'howto',
  data () {
    return {
      howtoMake: '',
      linkAmazonImg: '',
      linkAmazonText: '',
      curMethod: null,
      imgPath: this.$constants.DRIP.IMG,
      map: this.getMakeData()
    }
  },
  methods: {
    selectMethod (methodId) {
      this.curMethod = methodId
      this.imgPath = this.map[methodId].img
      this.loadHowtoMake()
    },
    getOptions () {
      return [
        { value: null, text: 'msg.choose-method' },
        { value: 1, text: this.map[1].name },
        { value: 2, text: this.map[2].name },
        { value: 3, text: this.map[3].name }
      ]
    },
    loadHowtoMake () {
      var method = null
      var countMsg = 0
      switch (this.curMethod) {
        case this.$constants.DRIP.ID:
          method = this.$constants.DRIP.NAME
          countMsg = 10
          break
        case this.$constants.FRENCH.ID:
          method = this.$constants.FRENCH.NAME
          countMsg = 9
          break
        case this.$constants.AERO.ID:
          method = this.$constants.AERO.NAME
          countMsg = 10
          break
      }
      this.howtoMake = '<ol>'
      for (var i = 1; i <= countMsg; i++) {
        let msgCode = this.$sprintf.sprintf('howto.%s.%d', method, i)
        this.howtoMake += this.$sprintf.sprintf('<li>%s</li>', this.$i18n.t(msgCode))
      }
      this.howtoMake += '</ol>'
    },
    init () {
    },
    showGram: function () {
      return this.curBaseBeansAmount.toFixed(1) + 'g'
    },
    getMakeData () {
      return {
        1: {
          method_name: this.$constants.DRIP.METHOD_NAME,
          beansAmount: this.$constants.DRIP.BEANS_AMOUNT,
          waterAmount: this.$constants.DRIP.WATER_AMOUNT,
          makeTime: this.$constants.DRIP.MAKE_TIME,
          img: this.$constants.DRIP.IMG
        },
        2: {
          method_name: this.$constants.FRENCH.METHOD_NAME,
          beansAmount: this.$constants.FRENCH.BEANS_AMOUNT,
          waterAmount: this.$constants.FRENCH.WATER_AMOUNT,
          makeTime: this.$constants.FRENCH.MAKE_TIME,
          img: this.$constants.FRENCH.IMG
        },
        3: {
          method_name: this.$constants.AERO.METHOD_NAME,
          beansAmount: this.$constants.AERO.BEANS_AMOUNT,
          waterAmount: this.$constants.AERO.WATER_AMOUNT,
          makeTime: this.$constants.AERO.MAKE_TIME,
          img: this.$constants.AERO.IMG
        }
      }
    }
  },
  computed: {
    showTime: function () {
      let min = Math.trunc(this.curTime / 10 / 60)
      let sec = Math.trunc(this.curTime / 10 % 60)
      let ms = Math.trunc(this.curTime % 10)

      return min.toString().padStart(2, 0) +
      ':' + sec.toString().padStart(2, 0) +
      '.' + ms.toString().padStart(1, 0)
    }
  },
  mounted () {
    this.init()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Howto.vue